module.exports = __webpack_public_path__ + "img/2.d00927c6.jpg";